var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Direction icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 23.8333C18.9831 23.8333 23.8333 18.9831 23.8333 13C23.8333 7.01691 18.9831 2.16667 13 2.16667C7.01691 2.16667 2.16667 7.01691 2.16667 13C2.16667 18.9831 7.01691 23.8333 13 23.8333Z",
    stroke: "#FD2D23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13 17.875V8.125",
    stroke: "#FD2D23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.66667 12.4583L13 8.125L17.3333 12.4583",
    stroke: "#FD2D23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirOut);
export default __webpack_public_path__ + "static/media/dir_out.cb88cce74df097c5adc106c187a33a15.svg";
export { ForwardRef as ReactComponent };